import { useGetEquityChart } from '#/api/generated/equity/equity';

import { normalizeProductTypeChartData } from './normalize';
import { ProductTypeChartSection } from './ProductTypeChartSection';
import type { ChartTimeframeId } from './types';

interface EquityChartSectionProps {
  symbol: string;
  initialTimeframe?: ChartTimeframeId;
  previousClose?: number | null;
}

export function EquityChartSection({
  symbol,
  initialTimeframe = '5Y',
  previousClose,
}: EquityChartSectionProps) {
  return (
    <ProductTypeChartSection
      symbol={symbol}
      initialTimeframe={initialTimeframe}
      useChartQuery={useGetEquityChart}
      normalizeChartData={normalizeProductTypeChartData}
      previousClose={previousClose}
    />
  );
}
